import React from 'react';
import { withRouter } from 'react-router-dom';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import UWCompanyUtil from '../../utils/UWCompanyUtil_TWIA.js';
import metadata from './AgentRegistrationCompletePage.metadata.json5';
import styles from './AgentRegistrationCompletePage.module.scss';


function AgentRegistrationCompletePage(props) {

    const { wizardData: registrationVM, updateWizardData, id } = props;
    const isTWIA = UWCompanyUtil.isTWIACompany(_.get(registrationVM, 'uwcompany'))


   const overrides = {
        regTfpaComplete: {
            visible: !isTWIA,
        },
        regTfpaConfirmation: {
            visible:  !isTWIA,
        },
        regComplete: {
            visible:  isTWIA,
        },
        regConfirmation: {
            visible:  isTWIA,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles, 
    };

    return (
        <WizardPage
            id={id}
            showPrevious={false}
            showNext={false}
            showCancel={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={registrationVM}
                onModelChange={updateWizardData}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

export default withRouter(AgentRegistrationCompletePage);